import React, { useEffect, useState, useRef } from 'react';
import { ASSET_CDN_URL } from '../../Constants';
import useAuth from '../../hooks/AuthHook.jsx';
import { useLocation, useNavigate } from 'react-router-dom';
import { NAVIGATION_OPTIONS } from '../BusinessConstants.js';
import { useOutsideClick } from '../../hooks/CommonHooks.jsx';
import useStore from '../../hooks/StoreHook.jsx';
import './StoreDropdown.scss';

const DisabledDropdownArrow = `${ASSET_CDN_URL}/dropdown/disabled-dropdown-arrow.svg`;
const DropdownArrow = `${ASSET_CDN_URL}/dropdown/dropdown-arrow.svg`;

const getStoreOptions = (stores) => {
  const storeOptions = stores
    .reduce((options, store) => ({...options, [store._id]: { key: store._id, text: store.name }, }), {});
  return storeOptions;
}

const StoreDropdown = ({ currentMode, onStoreChange = () => {} }) => {
  const { state } = useLocation();
  const { selectStoreId } = useStore();
  const navigate = useNavigate();
  const select = (storeId) => {
    if (storeId !== selected) {
      onStoreChange(storeId);
    }
    selectStoreId(storeId);
    navigate(NAVIGATION_OPTIONS[currentMode].url, { state: { ...state, storeId }})
  };
  const { profile } = useAuth();
  const { stores } = profile;
  const selected = (state && state.storeId) || stores[0]._id;
  const storeOptions = getStoreOptions(stores);
  const [open, setOpen] = useState(false);
  const storeListRef = useRef(null);
  const selectedStoreRef = useRef(null);
  const orderedStoreOptions = Object
    .keys(storeOptions)
    .sort((key1, key2) => storeOptions[key1].text.localeCompare(storeOptions[key2].text));
  const storeList = orderedStoreOptions.map(key => {
    const isSelected = key === selected;
    const onClick = () => {
      setOpen(false);
      select(storeOptions[key].key);
    }
    return (
      <li className={'store-item'} key={`store-option-${key}`}>
        <button
          className={`store-selection-button ${isSelected ? 'selected' : ''}`}
          onClick={onClick}
          ref={isSelected ? selectedStoreRef : null}
          aria-current={isSelected ? 'true' : undefined}
        >
          {storeOptions[key].text}
        </button>
      </li>
    );
  });
  const disabled = stores.length === 1;
  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => setOpen(false));
  const toggleDropdown = () => setOpen(!open);

  useEffect(() => {
    if (!open || !storeListRef.current || !selectedStoreRef.current) {
      return;
    }

    const selectedStoreItem = selectedStoreRef.current.parentElement;
    if (!selectedStoreItem) {
      return;
    }

    storeListRef.current.scrollTop = selectedStoreItem.offsetTop;
  }, [open, selected]);

  return (
    <section className={'store-dropdown'} ref={dropdownRef}>
      <button className={`store-selector ${disabled ? 'disabled' : ''}`} onClick={toggleDropdown} disabled={disabled}>
        <span className={'store-text'}>{storeOptions[selected].text}</span>
        <img className={`dropdown-arrow ${open ? 'open' : ''}`} src={disabled ? DisabledDropdownArrow : DropdownArrow} alt={'Dropdown arrow'} />
      </button>
      {open &&
        <section className={'store-selection-container'}>
          <ul className={'store-list'} ref={storeListRef}>{storeList}</ul>
        </section>
      }
    </section>
  );
}

export default StoreDropdown;
